import type {Editor} from 'grapesjs';
import type {SelectionSnapshot} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/rte/rte-selection.util';
import {copySelectionSnapshot} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/rte/rte-selection.util';
import {addBasicRteActions} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/rte/actions/basic';
import {addColorRteAction, updateColorPickerState} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/rte/actions/color';
import {addLinkRteAction, disableAndCloseCustomLinkBuilder, initHandlersForCustomURL} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/rte/actions/link';
import {addMergeTagsRteAction} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/rte/actions/merge-tags';

let rteInitialised = false;
let detachCustomURLHandlers: (() => void) | null = null;

export function addRte(editor: Editor): void {
  const rte = editor.RichTextEditor;
  const lastSnapshotRef: {value: SelectionSnapshot | null} = {value: null};

  editor.on('rte:enable', () => {
    if (!rteInitialised) {
      removeRTEDefaults(editor);
      addRTEActions(editor, lastSnapshotRef);
      detachCustomURLHandlers = initHandlersForCustomURL();
    }

    updateColorPickerState(rte, lastSnapshotRef);
    disableAndCloseCustomLinkBuilder(rte);
    rteInitialised = true;
  });

  editor.on('rteToolbarPosUpdate', (pos: {top: string}) => {
    pos.top = '100%';
  });
}

function removeRTEDefaults(editor: Editor): void {
  const rte = editor.RichTextEditor;
  rte.remove('bold');
  rte.remove('italic');
  rte.remove('underline');
  rte.remove('strikethrough');
  rte.remove('link');
  rte.remove('orderedlist');
  rte.remove('unorderedlist');
}

function addRTEActions(editor: Editor, lastSnapshotRef: {value: SelectionSnapshot | null}): void {
  const rte = editor.RichTextEditor;

  // When adding a formatting action, add its emitted style props to MEANINGFUL_FORMATTING_STYLE_PROPS (email-maker-rte-content-normalize.types.ts) or the formatting is stripped on blur.
  addColorRteAction(rte, lastSnapshotRef);
  addBasicRteActions(rte);
  addLinkRteAction(rte, editor);
  addMergeTagsRteAction(rte, editor);
}

export function resetRteInitFlag(): void {
  detachCustomURLHandlers?.();
  detachCustomURLHandlers = null;
  rteInitialised = false;
}

export type {SelectionSnapshot};
export {copySelectionSnapshot};
